import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function NegarimView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Scheme Name",
      children: prodd?.negName ?? "N/A",
    },
    {
      key: "5",
      label: "Status",
      children: prodd?.countyName ?? "N/A",
    },
    {
      key: "2",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "4",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "55",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    },
    {
      key: "6",
      label: "Latitudes",
      children: prodd?.negLat ?? "N/A",
    },
    {
      key: "7",
      label: "Longitudes",
      children: prodd?.negLong ?? "N/A",
    },
     
    {
      key: "9",
      label: "Number of Negarims",
      children: prodd?.negSize ?? "N/A",
    },
    {
      key: "10",
      label: "Slope of The Ground",
      children: prodd?.typoTypography ?? "N/A",  
    },
    {
      key: "11",
      label: "Area of Acres",
      children: prodd?.negCatchmentArea ?? "N/A",
    },
    {
      key: "12",
      label: "Types of Trees Grown",
      children: prodd?.negTreeTypeGrown ?? "N/A",
    },
    {
      key: "13",
      label: "Method of Water Harvesting",
      children: prodd?.whType ?? "N/A",
    },
    {
      key: "14",
      label:"Pathway",
      children: prodd?.negPathways?? "N/A",
    },
    
  ];

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Negarims Details</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Details"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default NegarimView;
